// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2FkXY","consentsList":"PatientConsents_consentsList__1R8ii","consentsListEmpty":"PatientConsents_consentsListEmpty__2DULy"};